export const typeStrategy = {
  'Geo::City': 'Cidade',
  'Geo::Country': 'País',
  'Geo::Region': 'Região',
  'Geo::State': 'Estado'
};
